<div class="pb-2">
    <label *ngIf="to.label && to.hideLabel !== true" [attr.for]="id">
        {{ to.label }}
        <span *ngIf="to.required && to.hideRequiredMarker !== true" class="k-required">*</span>
    </label>
    <kendo-multiselect *ngIf="dictionary !== undefined" [class.k-state-invalid]="showError" [formControl]="formControl"
        [formlyAttributes]="field" [class]="to.className" [data]="filtered" [textField]="'displayName'"
        [valueField]="'code'" (valueChange)="to.change && to.change(field, $event)" [valuePrimitive]="true"
        [filterable]="true" (filterChange)="filterDictionary($event)" (close)="searchTerm=''" [autoClose]="true"
        [virtual]="virtualDropdown">
        <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
            </span>
        </ng-template>
    </kendo-multiselect>
    <kendo-multiselect *ngIf="dictionary === undefined" [class.k-state-invalid]="showError" [formControl]="formControl"
        [formlyAttributes]="field" [class]="to.className" [data]="filtered" [textField]="'label'" [valueField]="'value'"
        (valueChange)="to.change && to.change(field, $event)" [valuePrimitive]="true" [filterable]="true"
        (filterChange)="filterText($event, to.options)" (close)="searchTerm=''" [autoClose]="true"
        [virtual]="virtualDropdown">
        <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <span innerHTML="{{ dataItem.label | highlight : searchTerm }}" class="ellipsis-text">
            </span>
        </ng-template>
    </kendo-multiselect>
    <small *ngIf="to.description" class="form-text text-muted">{{ to.description }}</small>
</div>